import React from 'react';
import { get } from 'lodash';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { NOT_FOUND_SEO_CONTEXT } from 'site-modules/shared/pages/seo';
import { EdmundsCpaNoAdhesionDecorator } from 'site-modules/shared/pages/decorators/edmunds-cpa-no-adhesion';
import { HTTP_NOT_FOUND } from 'client/utils/http-status';
import { ERROR_PAGES } from 'client/site-modules/shared/constants/error-page-names';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { updateVehicle } from 'client/actions/vehicle';
import { setCriticalCss } from 'client/actions/critical-css';
import { hasMostSoldTypeContent, hasSubsegments } from 'site-modules/shared/utils/upper-funnel/type-rankings';
import { FeatureFlagModel } from 'client/data/models/feature-flag';
import { LinkWidgetsModel, getPageLinksPath } from 'client/data/models/link-widgets';
import { TypePageDecorator } from 'site-modules/upper-funnel/decorators/type-page-decorator';
import { defineSeoContent } from 'site-modules/upper-funnel/utils/seo-content';
import { NativeAdsCreativeConfigModel } from 'client/data/models/native-ads-creative-config';
import { SEGMENT_LISTING_AD } from 'site-modules/shared/components/native-ad/utils/constants';
import {
  getCreativeConfigAdPathByVehicle,
  setAdsListToPreload,
  siteServedAdsCriticalCss,
} from 'site-modules/shared/components/native-ad/utils/utils';
import { HERO_BG_PATHS } from 'site-modules/upper-funnel/components/type/hero-content/hero-content';
import { PageModel } from 'client/data/models/page';

import { SEOModel } from 'client/data/models/seo';
import { BestRankingsPage, bestRankingsReturnedNoData } from './best-rankings';

export function getFirstObjectIfArray(objectOrArray) {
  return Array.isArray(objectOrArray) ? (objectOrArray.length > 0 && objectOrArray[0]) || {} : objectOrArray;
}

const pageConfig = {
  name: 'new_subtype_index',
  category: 'new_subtype_index',
  preload: store => {
    const preloader = new ModelPreloader(store);

    const state = store.getState();
    const { mobile } = state;

    preloader.resolve(getPageLinksPath(), LinkWidgetsModel);
    preloader.resolve('bestRankings', SEOModel);

    return preloader.load().then(() =>
      preloader.load().then(modelState => {
        const { rankings: rankingsArrayOrObject } = modelState.get('bestRankings', SEOModel);
        const rankings = getFirstObjectIfArray(rankingsArrayOrObject);
        const type = get(rankings, 'edmundsTypeCategory');
        const subtype = get(rankings, 'subtype');
        const vehicleEditorialRankings = get(rankings, 'segmentRatings');
        const vehicle = { type: { niceName: type } };
        setAdsListToPreload(preloader, store.getState(), [SEGMENT_LISTING_AD.AD_NAME], vehicle);
        store.dispatch(updateVehicle(vehicle));
        const siteServedAds = modelState.get(
          getCreativeConfigAdPathByVehicle(mobile, vehicle),
          NativeAdsCreativeConfigModel
        );

        const imageHref = mobile ? HERO_BG_PATHS.sm : HERO_BG_PATHS.lg;
        const assetsToPreload = [{ href: imageHref, as: 'image' }];
        preloader.set('server.preloadedAssets', PageModel, assetsToPreload);

        store.dispatch(
          setCriticalCss({
            type,
            criticalCssHeight: 2000,
            hasAnchorNav: hasSubsegments(vehicleEditorialRankings) || hasMostSoldTypeContent(type, subtype),
            ...siteServedAdsCriticalCss(siteServedAds),
            topRatedPromo: !!modelState.get('top-rated-promo', FeatureFlagModel),
          })
        );
        return preloader.load();
      })
    );
  },
  component: props => <BestRankingsPage {...props} />,
  decorator: TypePageDecorator,
  seo: (state, props) => {
    const bestRankings = get(state, 'seo.bestRankings');
    const rankings = getFirstObjectIfArray(get(bestRankings, 'rankings', {}));
    if (bestRankingsReturnedNoData(bestRankings)) {
      pageConfig.name = ERROR_PAGES.notFound;
      pageConfig.category = 'venom';
      pageConfig.decorator = EdmundsCpaNoAdhesionDecorator;
      pageConfig.status = HTTP_NOT_FOUND;
      pageConfig.chunkName = 'not_found_page';
      return NOT_FOUND_SEO_CONTEXT;
    }
    return defineSeoContent(state, props, get(rankings, 'edmundsTypeCategory'), get(rankings, 'subtype'), rankings);
  },
  options: {
    hasVehicleContext: true,
    isEditorialPageWithInlineMobileAd: true,
  },
};
export const pageDefinitionConfig = () => pageConfig;

export default params => pageDefinition(pageDefinitionConfig(params));
